import React from "react";

import { usePageUrlRedirectAliases } from "./usePageUrlRedirectAliases";
import { usePageFallbackCaseIdRedirect } from "./usePageFallbackCaseIdRedirect";
import { Spinner } from "components/common/Spinner";

export const CheckCaseIdWrapper = ({ children }) => {
  const { isLoading } = usePageFallbackCaseIdRedirect();
  usePageUrlRedirectAliases();

  return <>{isLoading ? <Spinner /> : children}</>;
};
